'use strict';

// Github scripts
import 'babel-polyfill';
import 'jquery';
import 'jquery.cookie';
import 'bootstrap';

// Custom scripts
import './common/lazyload';
import slicks from './common/slicks';
import checkDevice from './common/checkDevice';
import jQueryExtensions from './common/jQueryExtensions';
import setOffset from './common/setOffset';
import toggleGlass from './common/toggleGlass';
import fancybox from './common/fancybox';
import form from './common/form';
import datepicker from './common/datepicker';
import chosen from './common/chosen';
import mainSearchForm from './common/mainSearchForm';
import offerRecommendedOrderBy from './common/offerRecommendedOrderBy';

import enquiryModal from './enquiry/enquiryModal';
import contactView from './contact/contactView';
import comparisonView from './comparison/comparisonView';
import comparisonClear from './comparison/comparisonClear';
import searchView from './search/searchView';
import objectView from './object/objectView';

const OFFSET_BREAKPOINT = 1200;

checkDevice();

jQueryExtensions();

$(function () {
    setOffset(OFFSET_BREAKPOINT);

    toggleGlass();

    enquiryModal();

    contactView();

    comparisonView();

    comparisonClear();

    searchView();

    objectView();

    datepicker();

    fancybox();

    form();

    chosen();

    mainSearchForm();

    offerRecommendedOrderBy();

    $(window).on('resize orientationchange', () => {
        setOffset(OFFSET_BREAKPOINT);
    });

    slicks($('.js-slider-horizontal'), {
        arrows: true,
        slidesToShow: 4,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
        }]
    });

    slicks($('.js-slider-vertical'), {
        arrows: false,
        autoplay: true,
        slidesToShow: 4,
        vertical: true,
        responsive: [{
            breakpoint: 1200,
            settings: {
                arrows: true,
                slidesToShow: 3,
                vertical: false
            }
        }, {
            breakpoint: 768,
            settings: {
                arrows: true,
                slidesToShow: 2,
                vertical: false
            }
        }, {
            breakpoint: 480,
            settings: {
                arrows: true,
                slidesToShow: 1,
                vertical: false
            }
        }]
    });
});
